export const messages_vi = {
    nameEmpty: "Mục họ tên không được để trống",
    emailEmpty: "Địa chỉ email không được để trống",
    emailNotValid: "Địa chỉ email không hợp lệ, hãy điền lại thông tin",
    locationEmpty: "Nơi ở không được để trống",
    interests: "Hãy chọn 3 mục yêu thích của bạn",
    profileSaved: "Thông tin profile đã lưu",
    profilePic: "Ảnh đại diện đã lưu",
    addToFavorites:"Đã thêm vào thư mục yêu thích thành công",
    removeFromFavorites:"Đã xóa khỏi thư mục yêu thích thành công"
};


// WEBPACK FOOTER //
// ./src/constants/messages_vi.js